/*const firebaseConfig = {
  apiKey: "AIzaSyAMlOzVvlk2T9Gfs84aLK-jIKeBaVhrHGM",
  authDomain: "spried-bb41e.firebaseapp.com",
  //databaseURL: "https://spried-bb41e-default-rtdb.firebaseio.com",
  projectId: "spried-tools",
  storageBucket: "spried-tools",
  messagingSenderId: "559502217297",
  appId: "1:559502217297:web:a9409a5058c46ce9c6a870",
  measurementId: "G-F4ZKVQSBDN"
};
  
  export default firebaseConfig;
  */



import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage, ref, getDownloadURL,getBytes, uploadString } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMlOzVvlk2T9Gfs84aLK-jIKeBaVhrHGM",
  authDomain: "spried-bb41e.firebaseapp.com",
  databaseURL: "https://spried-bb41e-default-rtdb.firebaseio.com",
  projectId: "spried-bb41e",
  storageBucket: "spried-tools",
  messagingSenderId: "559502217297",
  appId: "1:559502217297:web:a9409a5058c46ce9c6a870",
  measurementId: "G-F4ZKVQSBDN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const analytics = getAnalytics(app);

const db = getFirestore(app,"spried-tools");

export { db,storage };
export default app;


